import { connect } from 'react-redux';
import { AppState } from '../../../../../types/store';
import { isCurrentUserProfileOwner } from '../../../../selectors/users';
import { getModuleDataByModuleType } from '../../../../selectors/modules';
import { ModuleType } from '../../../../../types/modules';
import { pinPostOnFeed } from '../../../../actions/feed';
import {
  editDeviation,
  deleteDeviation,
} from '@wix/da-shared-react/pkg/redux/deviations/actionCreators';

// TODO: cannot rely solely on deviationId, pseudo-deviations ids can collide
// with deviationIds. item typeIds must be taken into consideration as well.
const mapStateToProps = (state: AppState, ownProps) => {
  const pinnedDeviationId = getModuleDataByModuleType(
    state,
    ModuleType.FEED_PINNED_DEVIATION
  ).itemId;
  return {
    isCurrentUserProfileOwner: isCurrentUserProfileOwner(state),
    isPinned: pinnedDeviationId === ownProps.item.deviationId,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { item } = ownProps;
  return {
    onPin: () =>
      dispatch(
        pinPostOnFeed({
          item,
        })
      ),
    onUnpin: () =>
      dispatch(
        pinPostOnFeed({
          item: undefined,
        })
      ),
    onEdit: () =>
      dispatch(
        editDeviation({
          deviation: item,
        })
      ),
    onDelete: () =>
      dispatch(
        deleteDeviation({
          deviation: item,
        })
      ),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
);
